/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';
import { TOOLTIP_POSITION_TOP, TooltipPositionType } from './Tooltip.types';

/**
 * The props for `<Tooltip />`.
 */
export interface TooltipProps extends SdsDivProps {
  /**
   * Child component.
   */
  children?: React.ReactNode;

  /**
   * Tooltip label.
   */
  label: string;

  /**
   * The position of the tooltip around the element.
   */
  position?: TooltipPositionType;
}

/**
 * The default prop values for `<Tooltip />`.
 */
export const tooltipDefaults = {
  position: TOOLTIP_POSITION_TOP,
};
